module.exports = __webpack_public_path__ + "img/Employee.2959397d.svg";